import type { RouteObject } from "react-router";
import { RequireAuth } from "@/features/auth";

/**
 * /cabinet. The index is the cabinet hub (D35): public on phones (a guest sees «Войти», language, support), it sends a
 * signed-in desktop visitor to the first section. The sections need a logged-in customer and are lazy-loaded: their
 * code is downloaded only when a customer opens them.
 */
export const cabinetRoutes: RouteObject = {
  path: "cabinet",
  handle: { shell: { tab: "cabinet", canvas: true } },
  children: [
    {
      index: true,
      lazy: async () => ({ Component: (await import("./ui/CabinetHub")).CabinetHub }),
    },
    {
      element: <RequireAuth />,
      children: [
        {
          // sections are white pages on phones; the hub is a grey canvas with white blocks
          handle: { shell: { canvas: false } },
          lazy: async () => ({ Component: (await import("./ui/CabinetLayout")).CabinetLayout }),
          children: [
            {
              path: "orders",
              lazy: async () => ({ Component: (await import("./ui/OrdersPage")).OrdersPage }),
            },
            {
              path: "orders/:orderId",
              lazy: async () => ({
                Component: (await import("./ui/OrderDetailPage")).OrderDetailPage,
              }),
            },
            {
              path: "contracts",
              lazy: async () => ({
                Component: (await import("./ui/ContractsPage")).ContractsPage,
              }),
            },
            {
              // «Мой лимит» (ADR-0011): cards and the credit-bureau check
              path: "limit",
              lazy: async () => ({ Component: (await import("./ui/limit/LimitPage")).LimitPage }),
            },
            {
              path: "documents",
              lazy: async () => ({
                Component: (await import("./ui/DocumentsPage")).DocumentsPage,
              }),
            },
            {
              path: "bonuses",
              lazy: async () => ({ Component: (await import("./ui/BonusesPage")).BonusesPage }),
            },
            {
              path: "favorites",
              lazy: async () => ({
                Component: (await import("./ui/FavoritesPage")).FavoritesPage,
              }),
            },
            {
              path: "reviews",
              lazy: async () => ({ Component: (await import("./ui/ReviewsPage")).ReviewsPage }),
            },
            {
              path: "appeals",
              lazy: async () => ({ Component: (await import("./ui/AppealsPage")).AppealsPage }),
            },
            {
              path: "profile",
              lazy: async () => ({ Component: (await import("./ui/ProfilePage")).ProfilePage }),
            },
            {
              // MyID verification (ADR-0008); opened from contracts and the profile, not a menu section
              path: "verification",
              handle: { shell: { tabBar: false } },
              lazy: async () => ({
                Component: (await import("./ui/VerificationPage")).VerificationPage,
              }),
            },
          ],
        },
      ],
    },
  ],
};
